import { LOCALES } from "../constants";

export default {
    [LOCALES.GERMAN]: {
        "edit-file": "Bearbeiten Sie {file} und speichern Sie es, um es neu zu laden.",
        "hello": "Hallo",
    },
};
